import type { UserContext } from '../../domain/model/user-context/UserContext.types';
import type { ApiGetMeResponse } from './transportExecution.me.schema';

export const toUserContext = (src: ApiGetMeResponse): UserContext => ({
    roles: src.roles,
    dunsNumbersByRole: {
        consignee: src.duns_numbers_by_role.consignee,
        crossdock: src.duns_numbers_by_role.crossdock,
        freightForwarder: src.duns_numbers_by_role.freight_forwarder,
    },
});
